module.exports = __webpack_public_path__ + "static/img/icon_standard_alert.4695ac0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/GlobalRescue/icon_standard_alert.png
// module id = 9p2i
// module chunks = 1